import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import LibservAdditionalDocNew from "../../components/services/additionalDoc/LibservAdditionalDocNew";

const LibservAdditionalDocNewPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.new`)}>
      <LibservAdditionalDocNew />
    </PageWrapper>
  );
};

export default LibservAdditionalDocNewPage;
